<template>
  <div class="accept-page" v-loading.fullscreen.lock="loading">
    <main-image-section :img="destinationImg"></main-image-section>
    <div
      class="container"
      v-if="
        !loading &&
          !invitation.isAccepted &&
          !invitation.isExpired &&
          invitation.recipientFirstname
      "
    >
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h2 class="fnt font-deco">
              {{
                $t("ACCEPT__TITLE").replace(
                  "%name%",
                  invitation.recipientFirstname
                )
              }}
            </h2>
            <p class="fnt font-default" v-html="txt"></p>
          </div>

          <div class="content-narrow">
            <accept-invitation-form
              ref="form"
              :existing-user="userHasPlane"
              :firstname="invitation.recipientFirstname"
              :lastname="invitation.recipientLastname"
              :zip="invitation.zip"
              @onAccept="acceptInvitation"
            ></accept-invitation-form>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!loading">
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h2 class="fnt font-deco">
              {{
                $t("ACCEPT__TITLE_SUCCESS").replace(
                  "%name%",
                  invitation.recipientFirstname
                )
              }}
            </h2>
            <p class="fnt font-default" v-html="txtSuccess"></p>
          </div>
          <div class="block p-t-b content-narrow">
            <el-button type="primary" @click="createPlane" class="w100">
              {{ $t("ACCEPT__BTN_SUCCESS") }}
              <i class="fas fa-plane"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import to from "await-to-js"

import MainImageSection from "../components/Layout/MainImageSection"
import AcceptInvitationForm from "../components/Form/AcceptInvitationForm"
import InvitationService from "../services/api/InvitationService"

const invitationService = new InvitationService()

export default {
  name: "Accept",
  components: { MainImageSection, AcceptInvitationForm },
  data() {
    return {
      invitationId: null,
      token: null,
      invitation: {},
      loading: false
    }
  },
  computed: {
    txt() {
      if (!this.invitation.id) return ""

      const destination = this.invitation.sender.destination
      const destinationTitle =
        this.$i18n.locale === "fr"
          ? `${destination.article || ""} ${destination.titleFr}`
          : destination.titleEn

      return this.$t("ACCEPT__INVITATION_TXT")
        .replace(/%sender_firstname%/g, this.invitation.sender.firstname)
        .replace(/%sender_lastname%/g, this.invitation.sender.lastname)
        .replace(/%destination%/g, destinationTitle)
    },
    txtSuccess() {
      if (!this.invitation.id) return ""

      return this.$t("ACCEPT__TXT_SUCCESS")
        .replace(/%sender_firstname%/g, this.invitation.sender.firstname)
        .replace(/%sender_lastname%/g, this.invitation.sender.lastname)
    },
    destinationImg() {
      if (!this.invitation.id) return null

      return this.invitation.sender.destination.imgUrl
    },
    userHasPlane() {
      if (!this.invitation.id) return false

      return !!this.invitation.token
    }
  },
  methods: {
    createPlane() {
      this.$router.push({
        name: "register",
        query: { i: this.invitationId, t: this.token }
      })
    },
    acceptInvitation(invitation) {
      this.$gtag.event("InvitationAccepted")
      this.invitation = invitation

      // User has plane
      // User has plane
      const title = this.$t("SHARE_PAGE__INTRO_INVITED_BY").replace(
        "%name%",
        `${this.invitation.sender.firstname} ${this.invitation.sender.lastname}`
      )
      if (this.invitation.token) {
        this.$router.push({
          name: "share",
          query: { t: invitation.token, u: invitation.contestUserId },
          params: { customMsg: title }
        })
      } else {
        // New subscription
        if (window.fbq) {
          window.fbq(
            "trackSingleCustom",
            "776918872375668",
            "Inscrit VoyageDeReve"
          )
        }
      }
    }
  },
  async created() {
    this.loading = true
    this.invitationId = this.$route.query.i
    this.token = this.$route.query.t

    let invErr, invRes
    ;[invErr, invRes] = await to(
      invitationService.getInvitation(this.invitationId, this.token)
    )

    if (invErr) {
      this.$router.push({ name: "error" })
    }

    this.invitation = invRes

    if (this.invitation.isAccepted && this.userHasPlane) {
      const title = this.$t("SHARE_PAGE__INTRO_INVITED_BY").replace(
        "%name%",
        `${this.invitation.sender.firstname} ${this.invitation.sender.lastname}`
      )
      this.$router.push({
        name: "share",
        query: { t: this.invitation.token, u: this.invitation.contestUserId },
        params: { customMsg: title }
      })
    }

    this.loading = false
  }
}
</script>

<style scoped></style>
